// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../../types/selectors';
import { GRVersion } from '../../constants/meta';
import { GRGlobalStatuses } from '../../types/global';
import { selectIsGRUserForbidden } from '../user';

export const selectGRGlobalStatus = createSelector(
  (state) => state.gr.global?.status,
  (status) => status,
);

const selectGRGlobalVersion = createSelector(
  (state) => state.gr.global?.version,
  (version) => version,
);

export const selectIsGREnabled: Selector<boolean> = createSelector(
  [selectGRGlobalStatus, selectGRGlobalVersion],
  (globalStatus, version) =>
    // false /* Forcing deactivation */ &&
    (globalStatus === GRGlobalStatuses.RUNNING || globalStatus === GRGlobalStatuses.ENDING) && version === GRVersion,
);

export const selectIsGREnabledAndNotForbidden: Selector<boolean> = createSelector(
  [selectIsGREnabled, selectIsGRUserForbidden],
  (isGREnabled, isGRForbidden) => isGREnabled && !isGRForbidden,
);

export const selectIsGRPlayable: Selector<boolean> = createSelector(
  [selectIsGREnabledAndNotForbidden, selectGRGlobalStatus],
  (isGREnabled, globalStatus) => globalStatus === GRGlobalStatuses.RUNNING && isGREnabled,
);
